import React from 'react';
import { Card, Input, Space, Button, message } from 'antd';
import { keccak256 } from 'js-sha3';

const { TextArea } = Input;

const KeccakTool: React.FC = () => {
  const [inputText, setInputText] = React.useState('');
  const [hashResult, setHashResult] = React.useState('');

  // 计算Keccak256哈希
  const calculateHash = () => {
    if (!inputText.trim()) {
      message.error('请输入要计算哈希的文本');
      return;
    }

    try {
      const hash = keccak256(inputText);
      setHashResult('0x' + hash);
      message.success('哈希计算成功');
    } catch (error) {
      message.error('哈希计算失败');
    }
  };

  const copyHash = () => {
    if (hashResult) {
      navigator.clipboard.writeText(hashResult);
      message.success('已复制哈希值到剪贴板');
    }
  };

  const copyInput = () => {
    if (inputText) {
      navigator.clipboard.writeText(inputText);
      message.success('已复制输入文本到剪贴板');
    }
  };

  const clearAll = () => {
    setInputText('');
    setHashResult('');
    message.info('已清空所有内容');
  };

  return (
    <Card title="Keccak256 哈希" className="tool-container-responsive">
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>输入文本</div>
          <TextArea
            placeholder="输入要计算哈希的文本"
            value={inputText}
            onChange={e => setInputText(e.target.value)}
            rows={6}
          />
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <Space>
              <Button onClick={copyInput} disabled={!inputText}>
                复制输入
              </Button>
              <Button type="primary" onClick={calculateHash}>
                计算Keccak256
              </Button>
            </Space>
          </div>
        </div>

        <div>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>哈希结果</div>
          <Input
            placeholder="Keccak256哈希值将显示在这里"
            value={hashResult}
            readOnly
            style={{ fontFamily: 'monospace' }}
          />
          <div style={{ textAlign: 'right', marginTop: 8 }}>
            <Space>
              <Button onClick={copyHash} disabled={!hashResult}>
                复制哈希
              </Button>
              <Button onClick={clearAll}>
                清空
              </Button>
            </Space>
          </div>
        </div>

        <div style={{ 
          padding: 12, 
          background: '#f5f5f5', 
          borderRadius: 6, 
          fontSize: 12, 
          color: '#666' 
        }}>
          <div style={{ fontWeight: 500, marginBottom: 4 }}>说明：</div>
          <div>• Keccak256是以太坊使用的哈希算法</div>
          <div>• 输入相同的文本总是会得到相同的哈希值</div>
          <div>• 哈希值为64个十六进制字符（加上0x前缀）</div>
        </div>
      </Space>
    </Card>
  );
};

export default KeccakTool; 